<oe-chart [title]="'GENERAL.AUTARCHY' | translate">
    <autarchychart [isOnlyChart]="true">
    </autarchychart>
</oe-chart>
